import React from 'react'

const NavigationOptions = [
    {
        title: 'Income Asset',
        display: 'Income Asset',
        link: 'income',
        sidebarDescription: (
            <>
                <p>
                    Your income and the ability to earn and grow it over the course of your career
                    is your most valuable asset.
                </p>
                <p>
                    The <i>Income Asset</i> graph projects the value of your total income over the
                    course of your career from now until retirement.
                </p>
            </>
        ),
    },
    {
        title: 'Asset Comparison',
        display: 'Asset Comparison',
        link: 'assets',
        sidebarDescription: (
            <>
                <p>
                    Insuring other valuable assets that your income has provided is critical to your
                    overall financial protection; however, the value of these assets pale in
                    comparison to the value of your income.
                </p>
                <p>
                    The <i>Asset Comparison</i> graph shows a visual snapshot of your{' '}
                    <i>Income Asset</i> compared to the other assets you are currently insuring.
                </p>
                <p>
                    This also shows the difference in value between your <i>Income Asset</i> and
                    your <i>Consolidated Assets</i>.
                </p>
            </>
        ),
    },
    {
        title: 'Current Coverage',
        display: 'Current Coverage',
        link: 'coverage',
        sidebarDescription: (
            <>
                <p>
                    Having current coverage in place is important but understanding how it applies
                    precisely to your situation is crucial.
                </p>
                <p>
                    The <i>Current Coverage</i> graph shows how any existing employer group and/or
                    individually owned coverages compare to your income.
                </p>
            </>
        ),
    },
    {
        title: 'Income Loss Scenarios',
        display: 'Income Loss Scenarios',
        link: 'with-event-loss',
        sidebarDescription: (
            <>
                <p>
                    Understanding how a health event could affect your income is critical to your
                    overall financial wellbeing.
                </p>
                <p>
                    The <i>Coverage Scenarios</i> graph takes you through potential income loss
                    scenarios to help you better understand the financial impact of a medical event.
                </p>
                <p>
                    This also demonstrates how any existing coverage would perform under these
                    income loss situations.
                </p>
            </>
        ),
    },
    {
        title: 'Plan Comparison',
        display: 'Plan Comparison',
        link: 'plans',
        sidebarDescription: (
            <>
                <p>
                    Choosing the right plan to protect your income is essential to your financial
                    wellbeing.
                </p>
                <p>
                    The <i>Plan Comparison</i> graph shows additional coverage options along with
                    the estimated monthly premiums.
                </p>
                <p>
                    <b>
                        <i>Comprehensive</i>:{' '}
                    </b>
                    This plan is designed for individuals that fully understand the importance of
                    protecting their income and want to secure as much coverage as they can qualify
                    for.
                </p>
                <p>
                    <b>
                        <i>Moderate</i>:{' '}
                    </b>
                    This plan is designed for individuals who appreciate the need for a
                    comprehensive plan but may be more budget sensitive.
                </p>
                <p>
                    <b>
                        <i>Basic</i>:{' '}
                    </b>
                    This plan is generally designed for individuals with major budgeting concerns
                    and are looking to cover basic living expenses.
                </p>
            </>
        ),
    },
    {
        title: 'Coverage Scenarios',
        display: 'Coverage Scenarios',
        link: 'with-event',
        sidebarDescription: (
            <>
                <p>
                    Understanding how a health event could affect your income is critical to your
                    overall financial wellbeing.
                </p>
                <p>
                    The <i>Coverage Scenarios</i> graph takes you through potential income loss
                    scenarios to help you better understand the financial impact of a medical event.
                </p>
                <p>
                    This also demonstrates how additional coverage strategies could help mitigate
                    income loss in these situations.
                </p>
            </>
        ),
    },
    {
        title: 'Benefit Cost Comparison',
        display: 'Benefit Cost Comparison',
        link: 'asset-value',
        sidebarDescription: (
            <>
                <p>
                    Your income is not only your most important financial asset but is also the most
                    cost effective to protect, especially when compared to the other assets you
                    currently insure.
                </p>
                <p>
                    The <i>Benefit Cost Comparison</i> graph shows the value of your income
                    protection benefits compared to your other insured assets and estimated premiums
                    associated with them.
                </p>
            </>
        ),
    },
]

export default NavigationOptions
